export const STEP_STATUS = {
  COMPLETED: "Completed",
  IN_PROGRESS: "InProgress",
  PENDING: "Pending",
  AWAITING_USER: "AwaitingUser",
  FAILED: "Failed",
  CANCELLED: "Cancelled",
} as const;

export const SUB_STATUS = {
  AWAITING_OUTPUTS_APPROVAL: "AwaitingOutputsApproval",
  REQUIRES_ADDITIONAL_INFO: "RequiresAdditionalInformation",
  AWAITING_WORKFLOW_ENGINE: "AwaitingWorkflowEngine",
} as const;

export const SKELETON_COUNT = 10;
